<template>
  <div id="allProjects">
    <v-layout wrap row class="mb-4">
        <v-flex sm5 pr-3>
           <v-select
                width="100"
                class="filter_left"
                v-model="filterStatus" 
                label="Filter by status"
                :items="filterOptions"
                @change="updateList"
                >
              </v-select>
        </v-flex>
        <v-flex sm5 class="pr-3">
           <v-text-field
                v-model="search"
                append-icon="search"
                label="Search by Family / Project / PPN"
                hide-details
            ></v-text-field>
        </v-flex>
        <v-flex sm2>
          <v-btn v-if="projectList.length" class="pf-btn pf-bg-teal mt-3">
            <download-excel :data="projectList" :fields="exportFields" :name="`Video_Projects_list`">Print</download-excel>
          </v-btn>
        </v-flex>
    </v-layout>
      <v-card class="mt-5" v-if="filterStatus">
        <v-data-table
          :headers="headers"
          :items="projectList"
          :search="search"
          class="pf-data-table"
          ref="sortableTable"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <tr>
              <td class="pointer font-weight-bold light-blue--text" v-if="props.item.account && props.item.account.human" @click="logonFamily(props.item.account.human[0].user)">{{ props.item.account.name }}</td>
              <td>{{ props.item.account.contactInfo ? props.item.account.contactInfo.email : '--' }}</td>
              <td>
                <v-layout justify-center>
                <v-select
                v-if="props.item.video_status !== 'Completed'"
                :disabled="props.item.update_from === 'Default'"
                class="pt-0"
                  v-model="props.item.video_status"
                  :items="videoStatusList"
                  @change="statusChange(props.item)"
                ></v-select>
                <span class="green--text" v-else>{{ props.item.video_status }}</span>
              </v-layout>
              </td>
              <td :class="props.item.section.length > 0 ? 'pointer light-blue--text darken-1': ''" @click="props.item.section.length ? viewProjectDetails(props.item) : ''">{{ props.item.account ? `${props.item.account.ppn}` : '--' }}</td>
              <td align="center">{{ props.item.section.length }}</td>
              <td>{{ props.item.update_from === 'Default' ? 'In Progress' : 'Completed' }}</td>
              <td align="center">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small class="mr-0 ml-0" v-on="on">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                      <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                      </template>
                        <span>More</span>
                      </v-tooltip>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile :disabled="props.item.update_from === 'Default'">
                      <v-list-tile-action>
                        <v-icon size="22" color="grey darken-2">done</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title class="flex-center">
                        <v-checkbox @click="changeCompleteStatus(props.item)" :key="props.item.id" :disabled="props.item.update_from === 'Default'" :label="props.item.update_from === 'Complete' ? 'Completed' : 'Incomplete'" color="teal" v-model="swithToggle" :value="props.item.id"></v-checkbox>
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile target="_blank" @click="downloadPackage(props.item)" :disabled="props.item.update_from !== 'Complete'">
                      <v-list-tile-action>
                        <v-icon size="22" color="grey darken-2">save_alt</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        Download Package
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="viewProjectDetails(props.item, 1)">
                      <v-list-tile-action>
                        <v-icon size="22" color="grey darken-2">list_alt</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        Logs
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="viewProjectDetails(props.item, 2)">
                      <v-list-tile-action>
                        <v-icon size="22" color="grey darken-2">devices</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        Device Information
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-layout row justify-center>
        <v-dialog v-model="dialogLink" max-width="600" :persistent="true">
          <v-card>
            <v-form ref="linkForm">
            <v-card-text class="task-dialog">
              <v-layout row wrap>
                <v-flex class="text-xs-left" xs12>
                  <v-text-field label="Provide vimeo video link"
                    class="required" v-model="video.url" :rules="[videoLinkRule]"></v-text-field>
                  </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="pf-btn pf-btn-cancel" flat="flat" @click.native="dialogLink = false;cancelLink()">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" flat="flat" @click.native="saveLink();">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-layout>
  </div>
</template>
<script>
/* global session store config */
import Vue from 'vue';
import swal from 'sweetalert2';
import { getOne, getCollection, create, update } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import JsonExcel from 'vue-json-excel';

export default {
  name: 'AllProjects',
  components: {
    'downloadExcel': JsonExcel
  },
  data: () => ({
    swithToggle: [],
    search: '',
    headers: [
      { text: 'Family', value: 'account.name', align: 'left' },
      { text: 'Email', value: 'account.contactInfo.email', align: 'left' },
      { text: 'Video Status', value: 'video_status', sortable: false, align: 'center', width: '160px' },
      { text: 'Details', value: 'account.ppn', sortable: false, align: 'left' },
      { text: 'Sections', align: 'center' },
      { text: 'Status', value: 'update_from', sortable: false, align: 'left' },
      { text: 'Actions', sortable: false }
    ],
    filterStatus: 'All',
    dialogLink: false,
    editableProject: {},
    isVideoLinkValidated: false,
    tempVideoLink: null,
    video: {
      url: '',
      type: 'Vimeo',
      name: '',
      account: ''
    },
    projectList: [],
    videoStatusList: [
      'Open',
      'In Progress',
      'Completed'
    ],
    filterOptions: [
      { text: 'All', value: 'All' },
      { text: 'Family In-progress', value: 'Default' },
      { text: 'Family completed', value: 'Complete' },
      { text: 'Video Open', value: 'Open' },
      { text: 'Video In-progress', value: 'In Progress' },
      { text: 'Video Completed', value: 'Completed' },
    ],
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    exportFields: {
      'Family': 'account.name',
      'Project Name': 'title',
      'user Name': 'account.nickname',
      'email': 'account.contactInfo.email',
      'No of Sections': {
        field: 'section',
        callback: (value) => {
          return value.length;
        }
      },
    },
    config: config
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['AllProject']),
  },
  async created () {
    await this.getProjectList();
    this.swithToggle = this.AllProject.filter(p => p.update_from === 'Complete').map(proj => proj.id);
    if (this.AllProject.length) {
      this.updateList();
    }
  },
  methods: {
    // @vuese
    // Used to login to the family dashboard by admin
    // @arg The family object to which admin wants to login
    async logonFamily (userId) {
      let sessionData;
      // console.log('sessionData', sessionData);
      let { error, data } = await getOne('User', userId);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        delete data.access;
        sessionData = { ...session.getSession() };
        sessionData.adminUser = session.getSession().user;
        sessionData.user = data;
        session.setSession(sessionData, false);
        // window.location = config.client;
        location.reload();
      }
    },
    cancelLink () {
      this.$refs.linkForm.reset();
      this.video.url = '';
      this.video.account = '';
      this.updateList();
    },
    async saveLink () {
      if (this.$refs.linkForm.validate()) {
        this.dialogLink = false;
        this.isVideoLinkValidated = true;
        this.video.url = this.tempVideoLink;
        this.video.is_project_final = true;
        this.video.account = this.editableProject.account.id;
        let { error, data } = await create('Video', this.video);
        if (error) {
          console.log('error', error);
        } else {
          this.video.url = '';
          this.video.account = '';
          this.isVideoLinkValidated = false;
          this.editableProject.vimeo_link = this.tempVideoLink;
          this.changeCompleteStatus(this.editableProject, true);
        }
      }
    },
    // @vuese
    // Used to validate if the video is vimeo
    // @arg The video URL
    videoLinkRule (url) {
      if (!this.isVideoLinkValidated) {
        if (url !== undefined || url !== '') {
          let regExp2 = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
          let match2 = url ? url.match(regExp2) : '';
          if (match2) {
            this.tempVideoLink = 'https://player.vimeo.com/video/' + match2[3];
            return false;
          } else {
            return 'Please enter a vimeo video url';
          }
        }
      } else {
        return false;
      }
    },
    statusChange (item) {
      let list = ['In Progress', 'Open'];
      if (list.includes(item.video_status)) {
        this.changeCompleteStatus(item, true);
      } else {
        this.dialogLink = true;
        this.editableProject = item;
      }
    },
    updateList () {
      this.projectList = JSON.parse(JSON.stringify(this.AllProject));
      this.projectList = this.projectList.filter(project => (project.video_status === this.filterStatus || project.update_from === this.filterStatus || this.filterStatus === 'All'));
    },
    viewProjectDetails (projectItem, tab = null) {
      this.$router.push({ 
        path: `/admin/projects/${projectItem.id}`, 
        query: {
          preUrl: '/projectList', 
          accountId: `${projectItem.account.id}`,
          humanId: `${projectItem.account.human[0].id}`,
          ppn: `${projectItem.account.ppn}`,
          tab: tab
        }
      });
    },
    changedData () {
      this.selectedData = true;
    },
    downloadPackage (item) {
      if (item && item.update_from === 'Complete') {
        window.location.href = `${this.config.s3BucketPath}${this.config.s3Domain}/${item.account.human[0].id}/VideoProject/${item.id}/${item.account.ppn}.zip`;
      }
    },
    async changeCompleteStatus (item, video_status = false) {
      let editIndex = this.projectList.indexOf(item);
      if (!video_status) {
        item.video_status = 'Open';
        item.update_from = 'Default';
      } 
      let editableProject = JSON.parse(JSON.stringify(item));
      editableProject.account = editableProject.account.id;
      if (!video_status) {
        item.video_status = 'Open';
        editableProject.update_from = 'Default';
      }
      let { error, data, status } = await update('Project', editableProject, editableProject.id);
      if (error) {
        console.log('error', error);
      } else {
        data.account = item.account;
        this.projectList[editIndex] = data;
        this.AllProject.splice(this.AllProject.findIndex(project => project.id === item.id), 1, data);
        store.commit('setAllProject', this.AllProject);
        if (video_status && ['In Progress', 'Completed'].includes(item.video_status)) {
          await this.updateTimeline(item.video_status, item.vimeo_link, item.account.id);
        } else if (item.update_from === 'Default') {
          await this.updateTimeline(item.video_status, item.vimeo_link, item.account.id);
        }
        this.updateList();
        swal.fire({
          type: 'success',
          title: 'Project Details updated successfully',
          showConfirmButton: false,
          timer: 2500
        });
      }
    },
    async updateTimeline (status, link, account) {
      let text = '';
      if (status === 'Completed') {
        text = `Video Status changed to Completed,${link}`;
      } else if (status === 'In Progress') {
        text = 'Video Status changed to In Progress';
      } else {
        text = 'Video Project again Changed to Open';
      }
      let TimelineObj = {
        text: text,
        title: 'Project Video Status changed',
        account: account
      };
      let { error, data } = await create('Timeline', TimelineObj);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      }
    },
    async getProjectList () {
      if (!this.AllProject.length) {
        let populate = [{ 'path': 'account', populate: { path: 'human', select: 'user' }}];
        let { error, data } = await getCollection('Project', true, 0, populate);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setAllProject', data);
            this.updateList();
          }
        }
      }
    }
  }
};
</script>
<style scoped>
 #allProjects >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

#allProjects >>> .v-messages.theme--light {
    display: none !important;
}

#allProjects >>> .pointer {
  cursor: pointer;
}

#allProjects >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/VideoProject/allProjects.vue